import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App.tsx";
import "./index.css";
import { installPwaUpdateRecovery } from "./lib/pwaRecovery";
import { reportWebVitals } from "./perf/webVitals";

if (import.meta.env.PROD) {
  installPwaUpdateRecovery({ register: registerSW });
}

const root = createRoot(document.getElementById("root")!);
root.render(<App />);

// Start reporting Web Vitals (safe no-op if not configured)
reportWebVitals();
